import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../Layout/Layout";
import FooterNew from "../../Layout/FooterNew";
import axios from "axios";


function ProductReviews() {

const { prod_id } = useParams();
const navigate = useNavigate();


const [reviews,setReviews] = useState([]);
useEffect(()=>{
    const fetchReviews = async ()=>{
        try{
        const res = await axios.post(
            "https://ecom.cyberathon.com/index.php/Api/list_product_reviews",
            {
                prod_id:prod_id
            }
        );
        if(res.data.status === "true"){
            setReviews(res.data.data);
        }
        }catch(error){
            console.log(error);
        }
    };
    fetchReviews();
},[prod_id]);

/* ⭐ Static Reviews (abhi API nahi hai) */

// const reviews = [

// {
// name:"Raja Kumar Yadav",
// rating:3,
// title:"Nice",
// review:"Product was slightly damaged but usable.",
// time:"2 months ago",
// verified:true,
// images:[
// "https://rukminim2.flixcart.com/image/300/300/kz5vwy80/jean/j/f/g/28-grey-cargo-original-imagb8nqz.jpg",
// "https://rukminim2.flixcart.com/image/300/300/kz5vwy80/jean/1/z/x/28-grey-cargo-original-imagb8nqz.jpg"
// ]
// },

// {
// name:"Flipkart Customer",
// rating:5,
// title:"Awesome",
// review:"Best item thanks. Very satisfied.",
// time:"1 month ago",
// verified:true,
// images:[]
// },

// {
// name:"Rahul Sharma",
// rating:4,
// title:"Good Product",
// review:"Quality is good and delivery was fast.",
// time:"3 weeks ago",
// verified:true,
// images:[]
// }

// ];



const renderStars = (rating) => {

const stars = [];

for(let i=1;i<=5;i++){

stars.push(
<i
key={i}
className={`fa-star ${i<=rating ? "fa-solid text-warning":"fa-regular text-muted"}`}
></i>
);

}

return stars;

};

return (

<>

<Layout/>

<div className="container py-5">

{/* BACK BUTTON */}

<button
className="btn btn-light2 border mb-4 "
onClick={()=>navigate(-1)}
>
← Back
</button>

<h3 className="fw-bold mb-4">
Ratings & Reviews
</h3>

{/* ⭐ RATING SUMMARY */}

<div className="border rounded p-4 mb-5">

<h1 className="fw-bold mb-1">
3.6 ★
</h1>

<p className="text-muted">
256 Ratings • 54 Reviews
</p>

</div>

{/* ⭐ ALL REVIEWS */}

{reviews.map((r,i)=>(

<div
key={i}
className="border rounded p-4 mb-4"
>

<div className="d-flex align-items-center mb-2">

<span className="badge bg-success me-2">
{r.rating} ★
</span>

<strong>{r.review_title}</strong>

</div>

<div className="mb-2">
{renderStars(r.rating)}
</div>

<p className="mb-3">
{r.review_text}
</p>

{/* REVIEW IMAGES */}

{r.review_images.length > 0 && (

<div className="d-flex gap-2 mb-3 flex-wrap">

{r.review_images.map((img,index)=>(
<img
key={index}
src={`https://ecom.cyberathon.com/${img}`}
alt=""
style={{
width:"90px",
height:"70px",
objectFit:"cover",
borderRadius:"6px"
}}
/>
))}

</div>

)}

<div className="small text-muted">

<strong>{r.user_name}</strong>


<span className="ms-2">
• {r.time}
</span>

</div>

</div>

))}

</div>

<FooterNew/>

</>

);

}

export default ProductReviews;